<div class="toast" [ngClass]="appear ? 'toast--appear' : 'toast--disappear'">
    <app-icon *ngIf="messageType == 'error'" ic="IcErrorColored" size="m"></app-icon>
    <app-icon *ngIf="messageType == 'success'" ic="IcSuccessColored" size="m"></app-icon>
    <p class="toast__message text-body-s">{{ toastMessage }}</p>
</div>
